// Central API configuration — change URLs here to affect the whole app.
// Values are read from environment variables defined in .env

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;       // e.g. http://localhost:44311/api/services/app
export const AUTH_API_BASE_URL = process.env.REACT_APP_AUTH_API_BASE_URL; // e.g. http://localhost:44311/api
export const SIGNALR_BASE_URL = process.env.REACT_APP_SIGNALR_BASE_URL;   // e.g. http://localhost:44311
// Public origin the buyer's QR code points to. Development sets it in .env.development
// (the public tunnel a phone can reach). Production leaves it unset, so it falls back to
// the origin the app is actually served from - correct for any deployment, never localhost.
export const CLIENT_BASE_URL = (process.env.REACT_APP_CLIENT_BASE_URL || window.location.origin).replace(/\/+$/, '');

// Derived URLs
export const SIGNALR_NOTIFICATION_HUB = `${SIGNALR_BASE_URL}/signalr-notificationHub`;
export const SESSION_URL = `${API_BASE_URL}/Session/GetCurrentLoginInformations`;
export const BUYER_QR_BASE_URL = `${CLIENT_BASE_URL}/Buyer`;
